import React from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { ADMIN, GAME_MASTER } from './Roles';

const PrivateRoute = () => {
  const auth = useAuth();
  const location = useLocation();
  const params = useParams();

  if (auth?.token) {
      return <Outlet />;
  }

  if (location.pathname.startsWith("/games/") && params.id) {
      return (
        <Navigate
          to={`/games/${params.id}/login`}
          replace
          state={{ from: location }}
        />
      );
  } else {
      return (
        <Navigate
          to="/login"
          replace
          state={{ from: location }}
        />
      );
  }
};

export default PrivateRoute;